import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  mt: (p) => p.spacing(1.5),
};

export const placeholder: SxStyle = {
  mt: (p) => p.spacing(1.5),
  minHeight: (p) => p.spacing(6.5),
};
